<script setup lang="ts">
import type { FilterOption } from '~/components/SelectFilter.vue';

const props = defineProps<{
	row: any,
}>()

const { t } = useI18n()

const statuses:FilterOption[] = [
	{ key: 'wait_for_payment', label: t('wait_for_payment'), color: "yellow" },
	{ key: 'paid', label: t('paid_wait_for_kyc'), color: "emerald" },
	{ key: 'issuing', label: t('issuing'), color: "blue" },
	{ key: 'completed', label: t('completed'), color: "green" },
	{ key: 'refunded', label: t('refunded'), color: "gray" },
]

const ax_statuses: FilterOption[] = [
	{ key: "wait_for_create_user", label: t('wait_for_create_user'), color: "yellow" },
	{ key: "wait_for_create_user_error", label: t('wait_for_create_user_error'), color: "red" },
	{ key: "wait_for_card_issue", label: t('wait_for_card_issue'), color: "blue" },
	{ key: "wait_for_card_issue_error", label: t('wait_for_card_issue_error'), color: "red" },
	{ key: "wait_for_initial_topup", label: t('wait_for_initial_topup'), color: "green" },
	{ key: "wait_for_initial_topup_error", label: t('wait_for_initial_topup_error'), color: "red" },
	{ key: "active", label: t('active'), color: "green" },
	{ key: "wait_for_verify_activation", label: t('wait_for_verify_activation'), color: "yellow" }
]

const getDataFromObj = (arr: FilterOption[], searchVal: string) => arr.find(el => el.key === searchVal)
</script>

<template>
	<div class="flex flex-col gap-1 items-center">
		<UBadge
			:color="getDataFromObj(statuses, row.status)?.color || 'gray'"
			:label="getDataFromObj(statuses, row.status)?.label || row.ax_status"
			variant="solid"
		/>
		<UBadge
			v-if="row.ax_status && !(row.status === 'completed' && row.ax_status === 'active')"
			:color="getDataFromObj(ax_statuses, row.ax_status)?.color || 'gray'"
			:label="getDataFromObj(ax_statuses, row.ax_status)?.label || row.ax_status"
			variant="solid"
		/>
	</div>
</template>
